export default __webpack_public_path__ + "static/media/image14.fc742ccc.jpeg";